import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';
import routes from './routes';
import legacyRedirectRouteObject from './legacyRedirectRouteObject';
import gateRoutes from './gateRoutes';

const router = createBrowserRouter(
  [
    legacyRedirectRouteObject,
    ...gateRoutes(routes),
    {
      path: '*',
      // TODO eventually * should go to 404 page and index: true should go to rosters
      element: <Navigate to={NavConfig.groupConfigs.ROSTERS.to} />,
    },
  ],
  {
    basename: NavConfig.basename,
  }
);

export default router;
